import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const VARIANTS = {
  dark: "bg-coal text-paper hover:bg-cobalt",
  light: "bg-paper text-coal hover:bg-electric hover:text-white",
  blue: "bg-cobalt text-white hover:bg-electric",
  "outline-dark": "border border-ink/25 text-coal hover:border-coal hover:bg-coal hover:text-paper",
  "outline-light": "border border-paper/30 text-paper hover:border-paper hover:bg-paper hover:text-coal",
};

const CTAButton = ({ to, children, variant = "dark", className = "", testId, onClick, type }) => {
  const cls = `group inline-flex items-center justify-center gap-2.5 label-tech px-7 py-4 min-h-[44px] rounded-full transition-colors duration-500 ${VARIANTS[variant]} ${className}`;
  const inner = (
    <>
      {children}
      <ArrowUpRight size={15} className="transition-transform duration-500 ease-expo group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </>
  );
  if (to) {
    return (
      <Link to={to} data-testid={testId} className={cls} onClick={onClick}>
        {inner}
      </Link>
    );
  }
  return (
    <button type={type || "button"} onClick={onClick} data-testid={testId} className={cls}>
      {inner}
    </button>
  );
};

export default CTAButton;
